import { Reveal } from "./shared";

const STEPS = [
  { n: "01", label: "STEP ONE", name: "RESERVE", desc: "Save your free seat for the live masterclass." },
  { n: "02", label: "STEP TWO", name: "ATTEND", desc: "Join live and learn the Better Deal Method™: Clarify → Structure → Guide." },
  { n: "03", label: "AFTER THE CLASS", name: "APPLY", desc: "If you want personalized options, complete a mortgage application and authorizations after the class." },
  { n: "04", label: "AFTER THE CLASS", name: "REVIEW", desc: "Sit down with Josh for your one-on-one Better Deal Review™ and a clearer next step." },
];

export default function Roadmap() {
  return (
    <section className="border-y border-white/10" data-testid="roadmap-section">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-[#404653]/40">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1} className="relative">
            <div className="relative p-8 lg:p-10 overflow-hidden h-full" data-testid={`roadmap-step-${s.n}`}>
              <span
                className="absolute -top-4 -right-2 font-mono-strict font-bold text-white/[0.04] select-none pointer-events-none"
                style={{ fontSize: "9rem", lineHeight: 1 }}
              >
                {s.n}
              </span>
              <p className="font-mono-strict text-[10px] tracking-[0.3em] text-[#0162CA] mb-4">{s.label}</p>
              <h3 className="font-black uppercase text-xl tracking-tight mb-3">{s.name}</h3>
              <p className="text-white/50 text-sm leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
